import React from 'react';

export default function PriceChangePill({ pct }) {
  if (pct == null || pct === 0) return <span className="text-xs text-gray-400">--</span>;
  const isUp = pct > 0;
  return (
    <span
      className="inline-flex items-center text-xs font-medium"
      style={{
        borderRadius: 9999,
        padding: '2px 10px',
        fontSize: 12,
        background: isUp ? '#FEE2E2' : '#D1FAE5',
        color: isUp ? '#DC2626' : '#2D8F5E',
      }}
    >
      {isUp ? '▲' : '▼'} {Math.abs(pct).toFixed(1)}%
    </span>
  );
}
